// Object Graph
export const OBJECT_GRAPH_DIALOG_WIDTH = '95vw';
// even though we're setting the height to 100vh it will not fill the
// entire browser window due to max-height and inset-block-start properties set by atlaskit
export const OBJECT_GRAPH_DIALOG_HEIGHT = '100vh';
